module.exports = __webpack_public_path__ + "img/plan_znief2.5833cb9c.jpg";